/**
 * Canonical usernames are 3–20 chars of lowercase letters, digits and underscore. The "@" is a
 * display prefix only — it is never stored, never part of the Firebase Auth identity (the
 * synthetic sign-in email is `username@domain`, so an "@" inside would corrupt it) and never
 * counted when checking uniqueness. People may still type or paste "@name": the leading "@"s
 * are dropped so "@Name", "name" and " @name " are all the same account, and the prefix can
 * never be doubled on save or display.
 */
export const USERNAME_RE = /^[a-z0-9_]{3,20}$/

export function normalizeUsername(username: string): string {
  return username.trim().replace(/^@+/, '').trim().toLowerCase()
}

/** Text for the input control: the "@" is drawn by the UI, so strip any the user typed. */
export function stripAtPrefix(raw: string): string {
  return raw.replace(/@/g, '')
}

export function formatUsername(username: string | null | undefined): string {
  const u = normalizeUsername(username ?? '')
  return u ? `@${u}` : ''
}
